export function horizontalFlipping(slider) {

    let length = slider.find(".owl-item").length,
        containerClass = "js-flipping-container",
        container = $("<div/>", {
            class: containerClass
        });


    const containerNode = slider.find("." + containerClass);

    if (containerNode.length > 0) {
        containerNode.remove();
    }

    slider.prepend(container);

    container = slider.find("." + containerClass);

    let itemClass = "js-flipping-item";

    for (let i = 0; i < length; i++) {

        let item = $("<div/>", {
            class: itemClass
        });

        container.prepend(item);
    }

    addMoveSlider(slider, itemClass);
}

function addMoveSlider(slider, itemClass) {

    slider.find("." + itemClass).each(function() {

        const $el = $(this);
        let index = $el.index();

        moveSlider(slider, $el, index)
    });
}

function moveSlider(slider, item, index) {

    item.on("mouseenter", function() {

        slider.trigger("to.owl.carousel", [index]);
    });
}

